export const headers = {
	headers: {
		"Content-Type": "application/json",
	},
};

export const multipartHeaders = {
	headers: {
		"Content-Type": "multipart/form-data",
	},
};

export const BASE_URL = process.env.REACT_APP_API_URL || "https://nossomundoazul.com.br/api";
